import type { Input, TSize } from '~shared/ui/atoms/Input';

import { LeftIconBox, RightIconBox, StyledInput, Wrapper } from './styled';

export type Props = {
	leftIcon?: React.ReactNode;
	rightIcon?: React.ReactNode;
	uiSize?: TSize;
	onRightIconClick?: () => void;
} & React.ComponentProps<typeof Input>;

export const InputWithIcons = ({
	className,
	style,
	leftIcon,
	rightIcon,
	uiSize,
	disabled,
	onRightIconClick,
	...props
}: Props) => (
	<Wrapper className={className} style={style} uiSize={uiSize}>
		{leftIcon && (
			<LeftIconBox uiSize={uiSize} disabled={disabled}>
				{leftIcon}
			</LeftIconBox>
		)}
		<StyledInput
			uiSize={uiSize}
			disabled={disabled}
			hasLeftIcon={!!leftIcon}
			hasRightIcon={!!rightIcon}
			{...props}
		/>
		{rightIcon && (
			<RightIconBox
				role="button"
				uiSize={uiSize}
				disabled={disabled}
				onClick={onRightIconClick}
			>
				{rightIcon}
			</RightIconBox>
		)}
	</Wrapper>
);
